import React from "react";

const FooterBottom = () => {
  return (
    <div className="w-full dark-bg-front dark-text mb-20 md:mb-0 text-center p-2  font-medium ">
      &copy; {new Date().getFullYear()} <span>Thanos eShop</span>. Made with
      love ❤️
    </div>
  );
};

export default FooterBottom;
